module.exports = __webpack_public_path__ + "static/media/circle5.4ed90569.svg";